import React from 'react';
import { Grid, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from './style';
import { useHistory } from 'react-router-dom';
import { ArrowBack } from '@material-ui/icons';

interface Props {
  selectedIndex: number;
  personId?: string;
}

export function OfficialProfileNavbar(props: Props) {
  const { personId } = props;
  const { t } = useTranslation();
  const style = useStyles();
  const history = useHistory();

  function getButtonStyle(btnIndex: number) {
    const { selectedIndex } = props;
    if (selectedIndex === btnIndex) return 'outlined';
  }

  return (
    <Grid item container spacing={2} className={style.container} direction='row'>
      <Grid item>
        <Button onClick={() => history.push('/officials')} startIcon={<ArrowBack />}>
          {t('back')}
        </Button>
      </Grid>
      <Grid item container direction='row' xs={12} md={11}>
        <Grid item>
          <Button
            variant={getButtonStyle(1)}
            color='primary'
            onClick={() => personId && history.push(`/officials/official-details/${personId}`)}
          >
            {t('personal')}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant={getButtonStyle(2)}
            color='primary'
            onClick={() =>
              personId && history.push(`/officials/official-details/evaluations/${personId}`)
            }
          >
            {t('evaluations')}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant={getButtonStyle(3)}
            color='primary'
            onClick={() =>
              personId &&
              history.push(`/officials/official-details/evaluations-by-others/${personId}`)
            }
          >
            {t('evaluations_by_others')}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant={getButtonStyle(4)}
            color='primary'
            onClick={() =>
              personId && history.push(`/officials/official-details/tournaments/${personId}`)
            }
          >
            {t('tournaments')}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant={getButtonStyle(5)}
            color='primary'
            onClick={() =>
              personId && history.push(`/officials/official-details/roles-and-certs/${personId}`)
            }
          >
            {t('roles_and_certifications')}
          </Button>
        </Grid>
        <Grid item>
          <Button
            variant={getButtonStyle(6)}
            color='primary'
            onClick={() =>
              personId && history.push(`/officials/official-details/registrations/${personId}`)
            }
          >
            {t('registrations')}
          </Button>
        </Grid>
      </Grid>
      <Grid item />
    </Grid>
  );
}
